import React from 'react'
import { useQuery } from 'jsonapi-react'
import { useParams } from 'react-router-dom'
import ErrorPage from 'app/pages/ErrorPage'
import BuyTruckPage from './BuyTruckPage'
import config from './config'

export default function BuyTruckRouter() {
  const params = useParams()
  const placeSlug = config.vehicleTypes.includes(params.placeSlug)
    ? undefined
    : params.placeSlug

  const vehicleType = config.vehicleTypes.includes(
    placeSlug || params?.placeSlug
  )
    ? placeSlug || params.placeSlug
    : params?.vehicleType

  return (
    <BuyTruckListPage
      {...params}
      placeSlug={placeSlug}
      vehicleType={vehicleType}
    />
  )
}

function BuyTruckListPage(props) {
  const { placeSlug, vehicleType, page, params } = props

  const placeQuery = useQuery(
    placeSlug && [
      'places',
      {
        filter: {
          slug: placeSlug,
        },
        fields: {
          places: ['name', 'url_slug', 'location', 'major', 'market', 'active', 'region'],
        }
      },
    ]
  )

  if (placeQuery?.isLoading) {
    return null
  }

  if (placeQuery?.error) {
    return <ErrorPage />
  }
  if (!placeQuery?.data?.length) {
    return (
      <BuyTruckPage
        placeSlug={placeSlug}
        stateSlug={placeSlug}
        vehicleType={vehicleType}
        page={page}
        {...params}
      />
    )
  }

  const place = placeQuery.data[0]

  return (
    <BuyTruckPage
      city={place}
      stateSlug={place.url_slug.substr(-2, 2)}
      vehicleType={vehicleType}
      page={page}
      {...params}
    />
  )
}
